// Accessibilité du burger 
document.body.classList.toggle('js-enabled');

// SI L'ALERTE EST PRÉSENTE AJOUT D'UNE CLASS AU BODY.

if (document.querySelector('.AlertBanner') != null) {
  jQuery('body').addClass('alert-activated');
  let alertHeight = jQuery('.AlertBanner').innerHeight(); // valeur de la hauteur de l'alerte
  jQuery('.header').css({ top: alertHeight + 'px' }); // mettre la hauteur de l'alerte comme valeur à la position top du header
}
jQuery('.dismiss_icon').click(function () {
  jQuery('body').removeClass('alert-activated');
  jQuery('.header').css({ top: '0px' });
});

jQuery(document).ready(function($) {
  // Fonction de toggle pour les filtres
  $('.SidebarSearch__filters-item-header').click(function() {
    var parentItem = $(this).closest('.SidebarSearch__filters-item');
    
    // Toggle de la classe 'active'
    parentItem.toggleClass('SidebarSearch__filters-item--active');
    
    // SlideToggle pour ouvrir/fermer le contenu
    parentItem.find('.SidebarSearch__filters-item-content').slideToggle();
  });



  // Vos nouveaux SVG
  const newOpenedIcon = `
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="25px" height="25px" viewBox="0 0 25 25">
                    <svg width="25px" height="25px" viewBox="0 0 25 25" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Fill 1</title>
    <g id="Interfaces" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="FICHE-PRODUIT---V2" transform="translate(-1539, -1544)" fill="#FFFFFF">
            <g id="SECTION-PRODUITS" transform="translate(-151, 60)">
                <g id="Text" transform="translate(476, 190)">
                    <g id="Toggle-1" transform="translate(0, 1272)">
                        <path d="M1220.25,35.75 L1232.75,35.75 L1232.75,33.25 L1220.25,33.25 L1220.25,35.75 Z M1226.5,44.5 C1232.0225,44.5 1236.5,40.0225 1236.5,34.5 C1236.5,28.9775 1232.0225,24.5 1226.5,24.5 C1220.9775,24.5 1216.5,28.9775 1216.5,34.5 C1216.5,40.0225 1220.9775,44.5 1226.5,44.5 L1226.5,44.5 Z M1226.5,47 C1219.59625,47 1214,41.40375 1214,34.5 C1214,27.59625 1219.59625,22 1226.5,22 C1233.40375,22 1239,27.59625 1239,34.5 C1239,41.40375 1233.40375,47 1226.5,47 L1226.5,47 Z" id="Fill-1"></path>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
                </svg>`;
const newClosedIcon = `
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="25px" height="25px" viewBox="0 0 25 25"><svg width="25px" height="25px" viewBox="0 0 25 25" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Fill 1</title>
    <g id="Interfaces" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="FICHE-PRODUIT---V2" transform="translate(-1539, -1817)" fill="#006C64">
            <g id="SECTION-PRODUITS" transform="translate(-151, 60)">
                <g id="Text" transform="translate(476, 190)">
                    <g id="Toggle" transform="translate(0, 1272)">
                        <g id="Toggle-2" transform="translate(0, 273)">
                            <path d="M1226.5,44.5 C1232.0225,44.5 1236.5,40.0225 1236.5,34.5 C1236.5,28.9775 1232.0225,24.5 1226.5,24.5 C1220.9775,24.5 1216.5,28.9775 1216.5,34.5 C1216.5,40.0225 1220.9775,44.5 1226.5,44.5 L1226.5,44.5 Z M1226.5,47 C1219.59625,47 1214,41.40375 1214,34.5 C1214,27.59625 1219.59625,22 1226.5,22 C1233.40375,22 1239,27.59625 1239,34.5 C1239,41.40375 1233.40375,47 1226.5,47 L1226.5,47 Z M1225.25,33.25 L1225.25,28.25 L1227.75,28.25 L1227.75,33.25 L1232.75,33.25 L1232.75,35.75 L1227.75,35.75 L1227.75,40.75 L1225.25,40.75 L1225.25,35.75 L1220.25,35.75 L1220.25,33.25 L1225.25,33.25 Z" id="Fill-1"></path>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
                
                    </svg>`;

// Remplacement des SVG dans les balises e-opened et e-closed
$('.e-opened').html(newOpenedIcon); // Icône pour l'état ouvert
$('.e-closed').html(newClosedIcon); // Icône pour l'état fermé
});


